<script setup lang="ts">
import { RouterLink } from 'vue-router';
import StatCard from '@/components/ui/StatCard.vue';

defineProps<{
  count: number | null;
  loading?: boolean;
}>();
</script>

<template>
  <div data-testid="pending-approvals-stat">
    <RouterLink to="/board/residents/pending" class="block">
      <StatCard
        label="Pending approvals"
        :value="loading || count === null ? '—' : count"
        sub="Resident requests"
      />
    </RouterLink>
  </div>
</template>
